import Vue from 'vue'
import Vuex from 'vuex'
import vuexPersisted from 'vuex-persistedstate'
import product from './module/product'
import news from './module/news'
import job from './module/job'
// 注册
Vue.use(Vuex)
// 实例化
const store = new Vuex.Store({
  // 开启严格模式 仅允许mutations中的方法修改变量
  strict: true,
  // 1.state存储共享数据源 this.$store.state.变量
  state: {
    // baseUrl: 'http://localhost:8888'
  },
  // 2.mutations 同步操作state中的变量 this.$store.commit('方法',值)
  mutations: {
  },
  // 3.actions 异步修改state中的变量 this.$store.dispatch('方法',值)
  actions: {
  },
  // 4.getters 全局计算 this.$store.getters.计算属性名
  getters: {
    // getBaseUrl (state) {
    //   return state.baseUrl
    // }
  },
  // 5.modules 分模块
  modules: {
    // 5-1.namespaced 开启命名空间，防止重名
    // 5-2.state 变量 this.$store.state.模块名.变量名
    // 5-3.mutations 同步操作 this.$store.commit('模块名/方法',值)
    // 5-4.actions 异步操作 this.$store.dispatch('模块名/方法',值)
    // 5-5.getters 全局计算，this.$store.getters['模块名/计算属性名']
    product: product,
    news: news,
    job: job
  },
  // 6.vuex 持久化插件
  plugins: [vuexPersisted({storage: window.sessionStorage})]
})
// 导出store对象
export default store



// WEBPACK FOOTER //
// ./src/store/index.js